import React from 'react';

import './Loader.css';

const Loader = () => {
  return <span className='loader'>Cargando</span>;
};

export default Loader;
